
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Command } from "../Poker2Command";

export class GSUCommand extends Poker2Command {
    protected get cmdId(): string {
        return "gsu";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                var paramObj: any = JSON.parse(params[1]);
                Poker2Model.onTableData.parse_GSU(paramObj);
                return true;
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
